import React, { useEffect, useState } from "react";

// Gráfica de barras vertical sin dependencias.
// data: [{ label, value, color? }] — max define la escala (default: mayor valor).
const BarChart = ({ data = [], max, height = 150, formatValue }) => {
  const top = max || Math.max(...data.map((d) => d.value), 1);

  // Las barras crecen desde 0 al montar (transición CSS en height)
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const id = window.requestAnimationFrame(() => setReady(true));
    return () => window.cancelAnimationFrame(id);
  }, []);

  if (!data.length) return null;

  return (
    <div className="esen-bars" style={{ height }} role="img"
      aria-label={data.map((d) => `${d.label}: ${d.value}`).join(", ")}>
      {data.map((d, i) => {
        const pct = Math.min(Math.max(d.value / top, 0), 1) * 100;
        return (
          <div className="esen-bar-col" key={i} title={`${d.label}: ${d.value}`}>
            <span className="esen-bar-value">
              {formatValue ? formatValue(d.value) : d.value}
            </span>
            <div
              className="esen-bar-fill"
              style={{
                height: ready ? `${Math.max(pct, 2)}%` : "2%",
                background: d.color,
              }}
            ></div>
            <span className="esen-bar-label">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default BarChart;
